import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import BrainIcon from "../assets/brain.png";
import GrowthIcon from "../assets/growth.png";
import CalmIcon from "../assets/calm.png";
import GetEBookButton from "./GetEBookButton";
const CraftJourneySection = () => {
  const cards = [
    {
      title: "Science Meets Soul",
      description:
        "Built on Positive Psychology research but written from the heart of a mother. Every tool is simplified for real family life, turning proven emotional science into gentle, everyday moments of connection.",
      image: BrainIcon,
    },
    {
      title: "Growth for You and Your Child",
      description:
        "This is NOT just for your child, it’s for you too. You’ll learn how to stay calm through meltdowns, nurture resilience, and build emotional awareness together. It’s a parenting journey that grows both hearts, side by side.",
      image: GrowthIcon,
    },
    {
      title: "Calm, Simple, and Beautiful",
      description:
        "A printable, minimal design that feels peaceful to use. Each page is a breath of calm with reflection prompts, games, and gratitude practices that fit effortlessly into your day.",
      image: CalmIcon,
    },
  ];

  return (
    <Box component="section" sx={{ py: { xs: 4, md: 8 }, bgcolor: "custom.beige" }}>
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
          <Typography variant="h4" component="h2" fontWeight={700} gutterBottom>
            What You’ll Get Inside “Happy US”
          </Typography>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            Go from <b>overwhelmed parent</b> to <b>calm, confident nurturer</b>—in just a few pages a day.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            The <b>Happy US</b> isn’t just another parenting guide.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            It’s the <b>ONLY science-based, heart-centred toolkit</b> that helps you raise
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <b>emotionally intelligent, kind, grateful, and resilient children</b> through playful, practical,
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            and <b>beautifully designed activities</b> that strengthen real family connection.
          </Typography>
          <Typography variant="body1" sx={{ mt: 2, fontWeight: 700 }}>
            Here’s What Makes It Different…
          </Typography>
        </Box>
        {/* Cards Section */}
        <Grid container spacing={4}>
          {cards.map((card, index) => (
            <Grid
              item
              xs={12}
              md={4}
              key={index}
              sx={
                index === 1
                  ? {
                      pt: { xs: 0, md: 4 },
                      pb: { xs: 0, md: 4 },
                    }
                  : {}
              }
            >
              <Box
                sx={{
                  p: 3,
                  border: "1px solid",
                  borderColor: "grey.300",
                  borderRadius: 2,
                  textAlign: "center",
                  minHeight: { xs: 0, md: index === 1 ? 260 : 240 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  boxShadow: index === 1 ? 3 : 1,
                  bgcolor: index === 1 ? "grey.50" : "background.paper",
                  position: "relative",
                  pt: 0, // Remove top padding so image can overlap
                }}
              >
                <Box
                  component="img"
                  src={card.image}
                  alt={card.title}
                  sx={{
                    width: "110px",
                    height: "110px",
                    objectFit: "contain",
                    position: "absolute",
                    top: "-55px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    mb: 0,
                    zIndex: 2,
                    background: "white",
                    borderRadius: "50%",
                    boxShadow: 2,
                    border: "4px solid",
                    borderColor: "background.paper",
                  }}
                />
                <Box sx={{ mt: "70px" }}>
                  <Typography variant="h6" gutterBottom>
                    {card.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {card.description
                      .replace(
                        /Positive Psychology research|proven emotional science|real family life|resilience|emotional awareness|minimal design|reflection prompts|gratitude practices/gi,
                        (match) => `<b>${match}</b>`
                      )
                      .split(/(<b>.*?<\/b>)/g)
                      .map((part, i) =>
                        part.startsWith("<b>") ? (
                          <b key={i}>{part.replace(/<\/?b>/g, "")}</b>
                        ) : (
                          part
                        )
                      )}
                  </Typography>
                </Box>
              </Box>
              
            </Grid>
          ))}
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mt: 4,
                mb: -2,
                width: "100%",
                textAlign: "center",
              }}
            >
              <Box sx={{ textAlign: "center", mb: 3 }}>
                <Typography
                  variant="h4"
                  component="h2"
                  
                  fontWeight={400}
                  sx={{ color: "text.primary", fontSize: { xs: 26, md: 32 } }}
                  gutterBottom
                >
                  <strong>What’s Waiting for You Inside This Heartfelt Guide…</strong>
                </Typography>
              </Box>
              <Box sx={{ maxWidth: 600, mx: "auto", mb: 4 }}>
                <Typography
                  variant="h6"
                  component="div"
                  
                  fontWeight={400}
                  sx={{ color: "text.secondary", fontSize: { xs: 17, md: 20 } }}
                  gutterBottom
                >
                  <strong>Simple, science-backed activities</strong> that build emotional intelligence and gratitude.
                </Typography>
                <Typography
                  variant="h6"
                  component="div"
                  
                  fontWeight={400}
                  sx={{ color: "text.secondary", fontSize: { xs: 17, md: 20 } }}
                  gutterBottom
                >
                  <strong>Reflection prompts</strong> that help you connect deeply without big lectures or extra time.
                </Typography>
                <Typography
                  variant="h6"
                  component="div"
                  
                  fontWeight={400}
                  sx={{ color: "text.secondary", fontSize: { xs: 17, md: 20 } }}
                  gutterBottom
                >
                  <strong>Mindful parenting tools</strong> that bring calm to everyday routines.
                </Typography>
                <Typography
                  variant="h6"
                  component="div"
                  
                  fontWeight={400}
                  sx={{ color: "text.secondary", fontSize: { xs: 17, md: 20 } }}
                  gutterBottom
                >
                  <strong>Beautifully designed posters,</strong> worksheets, and rituals your kids will <em>actually love.</em>
                </Typography>
              </Box>
              <GetEBookButton />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CraftJourneySection;
